var map = {
	"./about1b.jpg": 3160,
	"./about2b.jpg": 2577,
	"./appstore.png": 2335,
	"./bandhoo-icon.png": 6036,
	"./bandhoo.jpg": 3122,
	"./bg/bg-01.png": 8733,
	"./bg/bg-02.png": 1895,
	"./bg/bg-03.png": 3430,
	"./bg/bg-04.png": 9261,
	"./bg/bg-05.jpg": 7897,
	"./bg/bg-06.jpg": 3061,
	"./bg/bg-07.jpg": 5788,
	"./bg/bg-08.jpg": 5522,
	"./bg/bg-09.jpg": 4897,
	"./bg/bg-10.png": 4464,
	"./clients/contractors/dynacon.jpg": 3009,
	"./clients/contractors/kec.jpg": 474,
	"./clients/contractors/lt.jpg": 4152,
	"./clients/contractors/nkg.jpg": 9331,
	"./clients/contractors/prithu5.jpg": 3741,
	"./clients/contractors/quess.jpg": 3866,
	"./clients/contractors/shbha2.jpg": 5390,
	"./clients/contractors/shobhaprojects.jpg": 3794,
	"./clients/contractors/tataprojects.jpg": 3846,
	"./clients/contractors/transrail.png": 4081,
	"./clients/contractors/vensa.jpg": 9794,
	"./clients/contractors/victoryone2.jpg": 2130,
	"./clients/developers/Embassy.png": 7013,
	"./clients/developers/adani.png": 2644,
	"./clients/developers/adaniTransparent.png": 8784,
	"./clients/developers/birla.png": 6690,
	"./clients/developers/brigade.png": 3891,
	"./clients/developers/cbre.png": 8339,
	"./clients/developers/century.png": 6644,
	"./clients/developers/client2.png": 4777,
	"./clients/developers/dlf.png": 33,
	"./clients/developers/elan.png": 7076,
	"./clients/developers/eldeco.png": 965,
	"./clients/developers/emaar.png": 4558,
	"./clients/developers/experion.png": 6571,
	"./clients/developers/gleeds.png": 4698,
	"./clients/developers/godrej.png": 3946,
	"./clients/developers/godrejproperties.png": 8289,
	"./clients/developers/jll.png": 5439,
	"./clients/developers/lodha.png": 4396,
	"./clients/developers/lodhaTransparent.png": 9284,
	"./clients/developers/lt.png": 5609,
	"./clients/developers/maia.png": 5696,
	"./clients/developers/maxEstates.png": 5036,
	"./clients/developers/piramalRealty.png": 9554,
	"./clients/developers/piramalRealtyTransparent.png": 8310,
	"./clients/developers/royalorchid.png": 1812,
	"./clients/developers/saifee.png": 2663,
	"./clients/developers/savills.png": 7807,
	"./clients/developers/thehouseofabhinandan.png": 577,
	"./clients/developers/tvs.png": 1492,
	"./constra/32543234_transparentO-4.png": 1198,
	"./constra/constra-build-main.png": 3902,
	"./constra/constra-scouter-main.png": 4101,
	"./constra/constra-survey-main.png": 9724,
	"./developersa.jpg": 7114,
	"./developersb.jpg": 3173,
	"./developersc.jpg": 219,
	"./digital-shramik/award1.jpg": 8418,
	"./digital-shramik/award2.jpg": 6781,
	"./digital-shramik/award3.jpg": 8112,
	"./digital-shramik/award4.jpg": 4895,
	"./digital-shramik/award5.jpg": 6772,
	"./googleplay2.png": 2596,
	"./home-collage.jpg": 5533,
	"./iso.png": 1616,
	"./laptop.png": 160,
	"./linkedin.png": 5975,
	"./loader.gif": 901,
	"./logom.png": 4232,
	"./playstore2.png": 5797,
	"./prashantgupta.jpg": 2669,
	"./ptt_about.jpg": 7790,
	"./ptt_faq.jpg": 9098,
	"./ptt_partner.jpg": 6734,
	"./ptt_service-1.jpg": 1135,
	"./slide6.jpg": 7404,
	"./soc.png": 6112,
	"./sridharsundaram.jpg": 7590,
	"./whatsappicon.png": 2566,
	"./whatsappwhite.png": 27,
	"./youtube1.png": 8770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;